import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import CustomLink from '../CustomLink';
import { Logo } from '../Logo';
import { COOKIE_POLICY_LINK, PRIVACY_POLICY_LINK, SUPPORT_EMAIL, TERMS_OF_USE_LINK } from '../../shared/links';
import styles from './Footer.css';

const cx = classnames.bind(styles);

function Footer({ className }) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <footer className={classes}>
            <div className={styles.wrapper}>
                <ul className={cx('links', 'bottomDivider')}>
                    <li>
                        <CustomLink
                            to={TERMS_OF_USE_LINK}
                            target='_blank'
                            className={styles.link}
                        >
                            Terms of Use
                        </CustomLink>
                    </li>
                    <li>
                        <CustomLink
                            to={PRIVACY_POLICY_LINK}
                            target='_blank'
                            className={styles.link}
                        >
                            Privacy&nbsp;Policy
                        </CustomLink>
                    </li>
                    <li>
                        <CustomLink
                            to={COOKIE_POLICY_LINK}
                            target='_blank'
                            className={styles.link}
                        >
                            Cookie Policy
                        </CustomLink>
                    </li>
                    <li>
                        <CustomLink
                            to={`mailto:${SUPPORT_EMAIL}`}
                            target='_blank'
                            className={styles.link}
                        >
                            {SUPPORT_EMAIL}
                        </CustomLink>
                    </li>
                </ul>
                <div className={styles.bottomWrapper}>
                    <Logo url={window.location.href} />
                    <address className={styles.address}>
                        © {new Date().getFullYear()} Jorefil Limited. Georgiou Christoforou 8, 1st floor, Strovolos, 2012, Nicosia, Cyprus. All rights reserved.
                    </address>
                    <div className={styles.separator} />
                </div>
            </div>
        </footer>
    );
}

Footer.propTypes = {
    className: PropTypes.string
};

Footer.defaultProps = {
    className: ''
};

export {
    Footer
};
